module.exports = __webpack_public_path__ + "static/media/p208gmotor.bd66bd2f.jpg";